import { getEnvConfig } from "@/config/env";

export const mainScreenDeepLinkUrl = "https://modulusbuymobile.page.link/app";
export const PaymentIconDefaultUrl =
  "https://modulus-seventeen-develop.s3.ap-south-1.amazonaws.com/icon/2f1838e4-fd05-4804-bc4e-d14765380a15-1000034575.png"; // todo change to new production one in next update
const currentEnv = 'production'; // 'local'// | 'development' | 'emulator' | 'production'
export const EnvConfig = getEnvConfig(currentEnv);

export const BaseApiUrl = EnvConfig.API_BASE_URL;
export const ModulusBuyBaseUrl = EnvConfig.BUY_URL;
export const ModulusSellBaseUrl = EnvConfig.SELL_URL;
